import React from 'react';
import { string, arrayOf } from 'prop-types';
import './endcap.scss';

const TopBar = ({ gradientColors }) => {

  if (!(Array.isArray(gradientColors) && gradientColors?.length)) return null;
  const GRADIENT_DIRECTION = '60deg';

  return (
    <>
      { gradientColors?.length > 1 && (
        <div
          className="topBar"
          style={{ background: `linear-gradient(${GRADIENT_DIRECTION}, ${gradientColors.join(',')})` }}
        />
      ) }
      { gradientColors?.length === 1 && (
        <div
          className="topBar"
          style={{ background: `${gradientColors[0]}` }}
        />
      )}
    </>
  );
};

TopBar.propTypes = {
  gradientColors: arrayOf(string)
};

TopBar.defaultProps = {
  gradientColors: ['#F96302']
};

export { TopBar };
